import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Grid, Form } from 'semantic-ui-react';
import moment from 'moment';

import { FieldEnum } from 'Common/FieldEnum';
import { SelectField, DatePickerField } from 'Common/SemanticWrapper';
import { TitledCard, StyledReduxFormError } from 'Components';

import 'react-datepicker/dist/react-datepicker.css';
import { IMPORT_LOG_FORM_NAME } from 'Common/FormEnum';
import { FailReasonOptions } from '../constants';

class ImportLogForm extends Component {
  render() {
    const { error } = this.props;

    return (
      <Form>
        <TitledCard title={'Report Parameters'}>
          <Grid columns={3} style={{ paddingBottom: '10px' }}>
            <Grid.Row>
              <Grid.Column>
                <Field
                  name={FieldEnum.FromDate}
                  component={DatePickerField}
                  type="text"
                  label="From"
                  openToDate={moment().add(-1, 'days')}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  name={FieldEnum.ToDate}
                  component={DatePickerField}
                  type="text"
                  label="To"
                  openToDate={moment()}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  name={FieldEnum.StudentImportFailReason}
                  component={SelectField}
                  type="text"
                  options={FailReasonOptions}
                  label="Fail Reason"
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>
        <StyledReduxFormError error={error} />
      </Form>
    );
  }
}

const validate = values => {
  const errors = {};

  if (!values[FieldEnum.AllDates]) {
    if (values[FieldEnum.FromDate]) {
      const fromDate = moment(Date.parse(values[FieldEnum.FromDate]));
      if (!fromDate.isValid()) {
        errors[FieldEnum.FromDate] = 'From date is required';
      }
    } else {
      errors[FieldEnum.FromDate] = 'From date is required';
    }

    if (values[FieldEnum.ToDate]) {
      const toDate = moment(Date.parse(values[FieldEnum.ToDate]));
      if (!toDate.isValid()) {
        errors[FieldEnum.ToDate] = 'To date is required';
      }
    } else {
      errors[FieldEnum.ToDate] = 'To date is required';
    }
  }

  if (values[FieldEnum.StudentImportFailReason] === undefined) {
    errors[FieldEnum.StudentImportFailReason] = 'Fail reason is required';
  }

  return errors;
};

export default reduxForm({
  validate,
  form: IMPORT_LOG_FORM_NAME,
  destroyOnUnmount: false,
})(ImportLogForm);



// WEBPACK FOOTER //
// ./src/pages/importlog/components/ImportLogForm.js